import { TitleCard } from '@warehouse/title/ui';
import { CommonReadonly, RelationshipType } from '@warehouse/title/core';
import React from 'react';
import { Divider, Typography } from '@mui/material';
import styled from 'styled-components';
import { WorkType } from '@warehouse/title-shared/core';
import { RelationshipModeRelationshipTypeSelectorContainer } from './RelationshipModeRelationshipTypeSelectorContainer';
import { LicensorSelectorReadonly } from './LicensorSelectorReadonly';
import { RelationshipModeWorkTypeSelectorContainer } from './RelationshipModeWorkTypeSelectorContainer';
import { TitleInfoWrapper } from './styles';
import { TitleCardService } from '../../../../libs/title/ui/title-card/title-card.service';

interface RelationshipModeHeaderProps {
	parentTitle: CommonReadonly;
	childWorkType?: WorkType;
	onSelectChildWorkType: (workType: WorkType | undefined) => void;
	relationshipType?: RelationshipType;
	onSelectRelationshipType: (relationshipType: RelationshipType) => void;
}

export function RelationshipModeHeader({
	parentTitle,
	childWorkType,
	onSelectChildWorkType,
	relationshipType,
	onSelectRelationshipType,
}: RelationshipModeHeaderProps) {
	const onSelectRelationshipTypeOverride = (newRelationshipType: RelationshipType) => {
		onSelectRelationshipType(newRelationshipType);
		onSelectChildWorkType(undefined);
	};

	return (
		<HeaderContainer>
			<RelationshipModeRelationshipTypeSelectorContainer
				parentTitle={parentTitle}
				selected={relationshipType}
				onSelect={onSelectRelationshipTypeOverride}
			/>
			<Divider orientation="vertical" />
			<TitleInfoWrapper>
				<Typography variant="s2Medium" color="text.primary">
					Parent Title:
				</Typography>
				<TitleCard {...TitleCardService.getTitleCardPropsFromTitleCommonReadonly(parentTitle)} variant="colored" />
			</TitleInfoWrapper>
			<Divider orientation="vertical" />
			<LicensorSelectorReadonly licensor={parentTitle.licensor.label} />
			<Divider orientation="vertical" />
			<RelationshipModeWorkTypeSelectorContainer
				relationshipType={relationshipType}
				onSelect={onSelectChildWorkType}
				selected={childWorkType}
			/>
		</HeaderContainer>
	);
}

const HeaderContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
`;
